import React from 'react';

import AssignActivitiesRouter from '../containers/AssignActivitiesRouter';
import DemoAccountContextProvider from '../contexts/DemoAccountContextProvider';
import AiRestrictionContextProvider from '../contexts/AiRestrictionContextProvider';

export default ({ isDemo = false, aiRestrictedGroup = null, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <AiRestrictionContextProvider aiRestrictedGroup={aiRestrictedGroup}>
      <AssignActivitiesRouter {...props} />
    </AiRestrictionContextProvider>
  </DemoAccountContextProvider>
);
